import React, { useState, useEffect, useRef, Fragment } from 'react';
import Header from '../commons/Header';
import Footer from '../commons/Footer';
import { useHistory, NavLink, Link } from "react-router-dom";
import { PROJECTNAMEALIAS, NFTAPIBASENAME, COLLECTIONIMAGEBASEURL, NFTIMAGEBASEURL } from '../helpers/Setup'
import { showToast, callAPI, showHttpError, checkIfUserIsLoggedIn, getAllSessionData, getCartDataAfterLoggedIn, showConfirmPurchase,handleCartManipulation } from '../helpers/Library';
import Loader from '../commons/Loader';





const Checkout = (props) => {
    const history = useHistory();
    const [showLoader, setShowLoader] = useState(false);
    const [cart, setCart] = useState([]);
    const [total, setTotal] = useState(0)
    const [grandTotal, setGrandTotal] = useState(0)
    const [gasFee, setGasFee] = useState(0)

    /* Method defination for retrieving all cart details */
    let getAllCartItems = () => {
        setShowLoader(true);
        callAPI('get', NFTAPIBASENAME + '/nft/market/getUserCartDetails?uuid=' + getAllSessionData().uuid, {}, true).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                let cartItems = response.cartItems;
                let arr = [];
                if (cartItems.length != null) {

                    for (let i = 0; i < cartItems.length; i++) {
                        let obj = {
                            id: cartItems[i].nftId,
                            name: cartItems[i].nftName,
                            price: cartItems[i].nftPrice,
                            collectionName: cartItems[i].nftCollectionName,
                            image: cartItems[i].nftFileName,
                            currencyCode: cartItems[i].networkName
                        }
                        arr.push(obj)
                    }
                    localStorage.setItem(PROJECTNAMEALIAS + 'cart', JSON.stringify(arr))
                    let cart = localStorage.getItem(PROJECTNAMEALIAS + 'cart');
                    if (cart != null && cart != undefined && cart != '') {
                        setCart(JSON.parse(localStorage.getItem(PROJECTNAMEALIAS + 'cart')));
                    } else {
                        setCart([])
                    }
                    let sum = 0
                    cart = JSON.parse(cart)
                    if (cart != null && cart.length > 0) {
                        for (let i = 0; i < cart.length; i++) {
                            console.log()
                            if (!isNaN(cart[i].price)) {
                                sum = sum + parseFloat(cart[i].price);
                            }
                        }
                        setTotal(sum);
                        let grandTotal = parseFloat(sum) 
                        setGrandTotal(grandTotal)
                    }
                }
            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })
    }

    /* Method defination for handling purchase */
    let handlePurchase = () => {
        let payload = { "userUuid": getAllSessionData().uuid, }
        setShowLoader(true);
        callAPI('post', NFTAPIBASENAME + '/nft/market/purchaseAll', payload, true).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                showConfirmPurchase(cart[cart.length - 1].name, NFTIMAGEBASEURL + '/' + cart[cart.length - 1].image)
                handleCartManipulation(cart, 'delete')
                localStorage.removeItem(PROJECTNAMEALIAS + 'cart')
                //getCartDataAfterLoggedIn();
                setTimeout(() => {
                    props.history.push("/");
                }, 2000);
            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })

    }





    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        if (!checkIfUserIsLoggedIn()) {
            showToast('error', 'Please login to continue',);
            setTimeout(() => {
                props.history.push("/");
            }, 1000);
        } else {
            getAllCartItems();

        }
    }, []);

    return (
        <Fragment>
            <Header />
            <div className="shop-box-inner">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h3>Checkout</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div className="odr-box">
                                <div className="title-left">
                                    <h3>Cart</h3>
                                </div>
                                <div className="rounded p-2 bg-light">
                                    {cart.map((nft) => (<div className="media mb-2 border-bottom" key={nft.id}>
                                        <div className="media-body">
                                            <a href="javascript:void(0);" className="row">
                                                <img src={NFTIMAGEBASEURL + '/' + nft.image} className="cart-thumb col-md-4" alt="" style={{ width: '50%', height: '50%' }} />
                                                <span className="col-md-6">{nft.name}</span>
                                                <div className="small text-muted col-md-2">{nft.price} ETH </div>
                                            </a>


                                        </div>
                                    </div>))}

                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div className="order-box">
                                <div className="title-left">
                                    <h3>Your order</h3>
                                </div>
                                <div className="d-flex">
                                    <div className="font-weight-bold">Product</div>
                                    <div className="ml-auto font-weight-bold">Total</div>
                                </div>
                                <hr className="my-1" />
                                <div className="d-flex">
                                    <h4>Sub Total</h4>
                                    <div className="ml-auto font-weight-bold"> {total} ETH </div>
                                </div>
                                {/* <div className="d-flex">
                                    <h4>Gas Fee</h4>
                                    <div className="ml-auto font-weight-bold"> {gasFee} ETH </div>
                                </div> */}
                                {/*  <hr className="my-1" />
                                <div className="d-flex">
                                    <h4>Coupon Discount</h4>
                                    <div className="ml-auto font-weight-bold"> $ 10 </div>
                                </div>
                                <div className="d-flex">
                                    <h4>Tax</h4>
                                    <div className="ml-auto font-weight-bold"> $ 2 </div>
                                </div>
                                <div className="d-flex">
                                    <h4>Shipping Cost</h4>
                                    <div className="ml-auto font-weight-bold"> Free </div>
                                </div> */}
                                <hr />
                                <div className="d-flex gr-total">
                                    <h5>Grand Total</h5>
                                    <div className="ml-auto h5"> {grandTotal} ETH </div>
                                </div>
                                <hr />
                            </div>
                            <div className="row">
                                <div className="col-md-8"></div>
                                <div className="col-md-4"> {cart.length > 0 && <button type="button" className="btn btn-primary " onClick={() => { handlePurchase() }}>Complete Purchase</button>}</div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>











            <Footer />
            <Loader show={showLoader} />
        </Fragment>
    );
}

export default Checkout;